import { render, staticRenderFns } from "./liquidaciones.vue?vue&type=template&id=40251320&"
import script from "./liquidaciones.vue?vue&type=script&lang=js&"
export * from "./liquidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports